<template lang="html">
  <div class="split"></div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.split {
    width: 100%;
    height: 16px;
    border-top: 1px solid rgba(7,17,27,0.1);
    border-bottom: 1px solid rgba(7,17,27,0.1);
    background: #f5f3f7;
}
</style>



// WEBPACK FOOTER //
// split.vue?d8b29334